const base = {
  default: {
    minHeight: '70px'
  }
};

const toggle = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type ToggleVariantsType = 'default';
export const toggleVariants = Object.keys(base) as ToggleVariantsType[];

export default toggle;
